













































import { Vue, Component } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { SaveAdquirenteUseCase } from '@/usecases'
import { Adquirente } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import CampoDeCnpj from '@/components/ui/CampoDeCnpj.vue'

@Component({
	components: {
		CampoDeCnpj,
	},
})

export default class DialogoDeEdicaoDeAdquirente extends Vue {
	adquirente: Adquirente | null = null
	mostra = false
	salvando = false
	saveAdquirenteUseCase = new SaveAdquirenteUseCase()
	obrigatorio = obrigatorio
	cadastroPadrao = true

	mostrar(adquirente: any, cadastroPadrao: boolean) {
		this.mostra = true
		this.adquirente = adquirente
		this.cadastroPadrao = cadastroPadrao
	}

	esconder() {
		this.mostra = false
	}

	async salvar() {
		if (!this.adquirente) return
		if (!this.adquirente.cnpjOuCpf || this.adquirente.cnpjOuCpf === '') return AlertModule.setError("Obrigatório informar CNPJ do adquirente")
		
		try {
			this.salvando = true
			const adquirente = {
				id: this.adquirente.id,
				razaoSocialOuNome: this.adquirente.razaoSocialOuNome.toUpperCase(),
				cnpjOuCpf: this.adquirente.cnpjOuCpf,
				ativo: this.adquirente.ativo ?? false,
			}
			const adquirenteSalvo = this.adquirente.id
				? await this.saveAdquirenteUseCase.update(adquirente)
				: await this.saveAdquirenteUseCase.create(adquirente)

			this.adquirente.id
				? this.$emit('update', adquirenteSalvo)
				: this.$emit('create', adquirenteSalvo)
			this.mostra = false
			AlertModule.setSuccess('Adquirente salvo com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}
}
